"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ToggleConstants_1 = require("./ToggleConstants");
const ToggleText = ({ children }) => ((0, jsx_runtime_1.jsx)("span", Object.assign({ className: `${ToggleConstants_1.BASE_TOGGLE_CLASS_NAME}_text` }, { children: children })));
exports.default = ToggleText;
